import api from "@/api/api";
import {iniciarRequisicao, logout} from "@/helpers";
import {STATUS_HTTP} from "../statusHTTP";

const PREFIXO = 'diagnostico';

export const buscarExcessoTotalEExcessoPorSegmentos = async (params) => {
  const url = `/${PREFIXO}/excesso-estoque/total-e-segmentos`;
  const {data, status} = await api.get(url, {params, headers: iniciarRequisicao()}).catch(logout);

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data;
}

export const buscarExcessoPorSegmentos = async (params) => {
  const url = `/${PREFIXO}/excesso-estoque/segmentos`;
  const {data, status} = await api.get(url, {params, headers: iniciarRequisicao()}).catch(logout);

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data.segmentos;
}

export const buscarExcessoPorFornecedores = async (params) => {
  const url = `/${PREFIXO}/excesso-estoque/fornecedores`;
  const {data, status} = await api.get(url, {params, headers: iniciarRequisicao()}).catch(logout);

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data.fornecedores;
}

export const buscarExcessoPorProdutos = async (params) => {
  const url = `/${PREFIXO}/excesso-estoque/produtos`;
  const {data, status} = await api.get(url, {params, headers: iniciarRequisicao()}).catch(logout);

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data.produtos;
}
